import React from 'react'
import { graphql, StaticQuery } from 'gatsby'

import Icon from './Icon'

function SocialsIcons() {
  return (
    <StaticQuery
      query={graphql`
        query {
          contentfulFooter {
            socialIcons {
              url
              image {
                title
                file {
                  url
                }
              }
            }
          }
        }
      `}
      render={({ contentfulFooter: socialIcons }) => (
        <div className="social__social-box">
          {socialIcons.socialIcons.map(iconData => (
            <Icon iconData={iconData} key={iconData.image.title} />
          ))}
        </div>
      )}
    />
  )
}

export default SocialsIcons
